import "core-js/modules/es7.object.get-own-property-descriptors.js";
import "core-js/modules/es6.symbol.js";
import "core-js/modules/es6.object.keys.js";
import "core-js/modules/web.dom.iterable.js";
import "core-js/modules/es6.object.to-string.js";
import "core-js/modules/es7.object.values.js";
import _defineProperty from "@babel/runtime/helpers/esm/defineProperty";
import _typeof from "@babel/runtime/helpers/esm/typeof";
import "core-js/modules/es6.array.iterator.js";
import "core-js/modules/es6.promise.js";
import "core-js/modules/es6.object.assign.js";
import "core-js/modules/es7.promise.finally.js";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

export var newRelicCall = function newRelicCall(_ref) {
  var msg = _ref.msg,
      level = _ref.level,
      customFilter = _ref.customFilter;

  if (process.client && window && window.newrelic) {
    var newRelicMessage = msg;

    if ((typeof message === "undefined" ? "undefined" : _typeof(message)) === 'object') {
      newRelicMessage = JSON.stringify(msg);
    }

    window.newrelic.noticeError(newRelicMessage, _objectSpread({
      'mdm-errors': 'mdm-errors',
      'log-level': level || 'error',
      'mdm-console': level || 'error'
    }, customFilter && {
      'custom-filter': customFilter
    }));
  }
};
export var transformArgumentsToString = function transformArgumentsToString(args) {
  return Object.values(args).map(function (arg) {
    return _typeof(arg) === 'object' ? JSON.stringify(arg) : arg;
  }).join(' ');
};
export var logError = function logError(_ref2) {
  var msg = _ref2.msg;
  console.error(msg);
  newRelicCall({
    msg: msg
  });
};